import React, { useEffect, useState } from "react";
import { RoomCard } from "./RoomCard";

export const ByRoomTab = ({
  rooms,
  onOpenAddItemModal,
  onAddInclusion,
  addingInclusion,
  onEditBoq,
  onDeleteBoq,
  onDeleteInclusion,
  onBudgetUpdated,
  projectId,
  defaultExpanded = false,
  showCostFields = true,
  viewOnly = false,
  isDisable = false,
  inlineEditingBoqId,
  inlineEditingBoqInclusion,
  onSaveInlineEditBoq,
  onCancelInlineEditBoq,
  inlineEditSaving,
  isMobile = false,
  isTablet = false,
  project,
  isSiteVisit = false,
  isSiteEstimatesRoute = false,
  isReview = false,
  isExpanded = false,
  fetchAvailableInclusionsForRoom,
}) => {
  const [expandedRooms, setExpandedRooms] = useState(() => {
    const next = {};
    (rooms || []).forEach((r) => {
      next[r.room_id] = !!defaultExpanded;
    });
    return next;
  });

  const [availableInclusionsByRoomId, setAvailableInclusionsByRoomId] = useState({});
  const [isLoadingAvailableInclusionsByRoomId, setIsLoadingAvailableInclusionsByRoomId] = useState({});
  const [hasFetchedAvailableInclusionsByRoomId, setHasFetchedAvailableInclusionsByRoomId] = useState({});

  useEffect(() => {
    setExpandedRooms((prev) => {
      const next = { ...prev };
      (rooms || []).forEach((r) => {
        if (next[r.room_id] === undefined) next[r.room_id] = !!defaultExpanded;
      });
      return next;
    });
  }, [rooms, defaultExpanded]);

  if (!rooms || rooms.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 256,
        }}
      >
        <div style={{ fontSize: 16, color: "#4b5563" }}>
          No rooms found for this project
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {rooms.map((room) => (
        <div key={room.room_id}>
          <RoomCard
            room={room}
            onOpenAddItemModal={onOpenAddItemModal}
            onEditBoq={onEditBoq}
            onDeleteBoq={onDeleteBoq}
            onDeleteInclusion={onDeleteInclusion}
            onBudgetUpdated={onBudgetUpdated}
            onRoomExpandedChange={async (roomId, expanded, roomName) => {
              setExpandedRooms((prev) => ({ ...prev, [roomId]: expanded }));
              if (!expanded) return;
              if (hasFetchedAvailableInclusionsByRoomId[roomId]) return;
              if (typeof fetchAvailableInclusionsForRoom !== "function") return;

              setIsLoadingAvailableInclusionsByRoomId((prev) => ({ ...prev, [roomId]: true }));
              try {
                const data = await fetchAvailableInclusionsForRoom(roomName);
                if (data?.success) {
                  setAvailableInclusionsByRoomId((prev) => ({ ...prev, [roomId]: data }));
                  setHasFetchedAvailableInclusionsByRoomId((prev) => ({ ...prev, [roomId]: true }));
                }
              } catch (error) {
                console.error("Error fetching available inclusions:", error);
              } finally {
                setIsLoadingAvailableInclusionsByRoomId((prev) => ({ ...prev, [roomId]: false }));
              }
            }}
            projectId={projectId}
            defaultExpanded={defaultExpanded}
            isDisable={isDisable}
            showCostFields={showCostFields}
            viewOnly={viewOnly}
            inlineEditingBoqId={inlineEditingBoqId}
            inlineEditingBoqInclusion={inlineEditingBoqInclusion}
            onSaveInlineEditBoq={onSaveInlineEditBoq}
            onCancelInlineEditBoq={onCancelInlineEditBoq}
            inlineEditSaving={inlineEditSaving}
            isMobile={isMobile}
            isTablet={isTablet}
            project={project}
            isSiteVisit={isSiteVisit}
            isSiteEstimatesRoute={isSiteEstimatesRoute}
            isReview={isReview}
            isExpanded={isExpanded}
          />

          {/* {!viewOnly && !isDisable && expandedRooms[room.room_id] && (
            <div style={{ marginTop: 12, marginBottom: 40 }}>
              {!isExpanded && (
                <h4
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#0D0D0E",
                    marginBottom: 16,
                    margin: 0,
                  }}
                >
                  Available Inclusions for {room.room_name}
                </h4>
              )}

              {isLoadingAvailableInclusionsByRoomId[room.room_id] ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "32px 0",
                  }}
                >
                  <span style={{ marginLeft: 8, color: "#4b5563" }}>
                    Loading available inclusions...
                  </span>
                </div>
              ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
                  {(availableInclusionsByRoomId[room.room_id]?.inclusions || []).map(
                    (inclusion) => {
                      const addedInclusionNames = (room?.inclusions || []).map((i) => i.name);
                      const isAlreadyAdded = addedInclusionNames.includes(inclusion.inclusion_name);
                      const isAdding = addingInclusion === inclusion.inclusion_name;
                      return (
                        <button
                          key={inclusion.inclusion_id}
                          onClick={() =>
                            !isAlreadyAdded &&
                            onAddInclusion?.(inclusion.inclusion_name, room.room_id)
                          }
                          disabled={isAlreadyAdded || isAdding}
                          style={{
                            padding: "10px 14px",
                            fontSize: 12,
                            fontWeight: 500,
                            borderRadius: 8,
                            border: "1px solid",
                            borderColor: isAlreadyAdded ? "#e5e7eb" : "#d1d5db",
                            background: isAlreadyAdded ? "#f9fafb" : "#fff",
                            color: isAlreadyAdded ? "#9ca3af" : "#4b5563",
                            cursor: isAlreadyAdded || isAdding ? "not-allowed" : "pointer",
                            opacity: isAdding ? 0.6 : 1,
                          }}
                        >
                          {isAdding
                            ? "Adding..."
                            : isAlreadyAdded
                            ? `✓ ${inclusion.inclusion_name}`
                            : `+ ${inclusion.inclusion_name}`}
                        </button>
                      );
                    },
                  )}
                </div>
              )}
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
};

export default ByRoomTab;
